// extracted by mini-css-extract-plugin
export default {"contactsSection":"Contacts_contactsSection__etrnD","contactsContainer":"Contacts_contactsContainer__upyqi","form":"Contacts_form__8KQ2P"};